/** 대표 공급평형 선택에 사용하는 평형대 우선순위를 반환한다. */
export const getPyeongPriority = (pyeong) => {
  if (pyeong == null || !Number.isFinite(Number(pyeong))) return 6;
  const value = Number(pyeong);
  if (value >= 30 && value < 40) return 0;
  if (value >= 20 && value < 30) return 1;
  if (value >= 40 && value < 50) return 2;
  if (value >= 50 && value < 60) return 3;
  if (value >= 10 && value < 20) return 4;
  if (value >= 60) return 5;
  return 6;
};

/** 두 공급평형 중 대표 평형 우선순위가 높은 row를 앞에 정렬한다. */
const compareRepresentativePyeong = (left, right) => {
  const priorityDiff = getPyeongPriority(left?.pyeong) - getPyeongPriority(right?.pyeong);
  if (priorityDiff !== 0) return priorityDiff;
  const leftDistance = left?.pyeong == null ? Number.POSITIVE_INFINITY : Math.abs(Number(left.pyeong) - 30);
  const rightDistance = right?.pyeong == null ? Number.POSITIVE_INFINITY : Math.abs(Number(right.pyeong) - 30);
  return leftDistance - rightDistance;
};

/** 공급평형 검색 결과에서 아파트별 대표 평형 하나를 선택한다. */
export const selectRepresentativePyeongs = (results = []) => {
  const selected = new Map();
  results.forEach((row, index) => {
    // aptId가 없는 비정상 row끼리는 하나로 합치지 않는다.
    const key = row?.aptId || `missing-apt-${index}`;
    const existing = selected.get(key);
    if (!existing || compareRepresentativePyeong(row, existing) < 0) {
      selected.set(key, row);
    }
  });
  return Array.from(selected.values());
};

/** 전체 평형을 아파트명으로 묶고 같은 아파트 안에서는 평형 오름차순으로 정렬한다. */
export const sortAllPyeongs = (results = []) => [...results].sort((left, right) => {
  const nameDiff = `${left?.aptName || ""}`.localeCompare(`${right?.aptName || ""}`, "ko");
  if (nameDiff !== 0) return nameDiff;
  const aptDiff = `${left?.aptId || ""}`.localeCompare(`${right?.aptId || ""}`);
  if (aptDiff !== 0) return aptDiff;
  const leftPyeong = left?.pyeong == null ? Number.POSITIVE_INFINITY : Number(left.pyeong);
  const rightPyeong = right?.pyeong == null ? Number.POSITIVE_INFINITY : Number(right.pyeong);
  return leftPyeong - rightPyeong;
});
